import styled, { css } from 'styled-components';
import BinaModal from '../../ReactModal';
import { defaultStyles } from '../../../styled/constants';
import { FlexCenterAligned, FlexColumn } from '../../../styled/common';
import { tagStyles } from '../Typography/styles';

export const StyledPopup = styled(BinaModal)`
  ${({ styles }) => styles}
`;

export const Content = styled(FlexColumn)`
  padding: 20px;
  gap: 10px;
  align-items: center;
  text-align: center;
  font-family: ${defaultStyles.fontFamily};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  ${tagStyles.h3}
`;

export const Message = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  ${tagStyles.body_2}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${({ isColumn }) =>
    isColumn &&
    css`
      flex-direction: column;
    `}
`;

export const Button = styled(FlexCenterAligned)`
  ${tagStyles.body_1}
  width: 100%;
  height: 50px;
  cursor: pointer;

  ${({ borderRight }) =>
    borderRight &&
    css`
      border-right: 1px solid ${({ theme }) => theme.colors.border.primary};
    `}
  ${({ borderBottom }) =>
    borderBottom &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    `}
  ${({ color, theme }) => css`
    color: ${color || theme.colors.text.primary};
  `}
`;
